<template>

  <div v-bind:class="{'editarea': auth.user.owner && !editmode}" v-if="auth.user.owner">
    <div  v-if="textblock && editmode && auth.user.owner">

      <editor
         api-key="no-api-key"
         v-model="textblock.text"
         :plugins="myPlugins"
         :toolbar ="myToolbar1"
         :init="myInit"
       />


      <button style="margin-top:1em;"  @click.prevent="storeText">speichern</button>
    </div>
    <div v-if="!editmode"  v-html="textblock.text"></div>
    <img @click="editmode = 1;" v-if="!editmode" style="cursor:pointer;width:25px; height:auto;" src="/img/icons/edit.png" />
  </div>
  <div v-else v-html="textblock.text"></div>
  <br>




</template>



<script>


 import Editor from '@tinymce/tinymce-vue'

export default {
  components: {
    'editor': Editor
  },
  props: {
    textblocks: Object,
    textid: String,
    auth: Object,
  },
  mounted() {
   let app = this;
   setTimeout(function() {
       app.textblock = app.textblocks.find(x => x.id === app.textid);
   }, 5);

 },

  data() {
    return {
      selectedEvent: {},
      showDialog: false,
      textblock: 'no',
      editmode: 0,
      myToolbar1: 'undo redo | bold italic underline |  h2 h3 | image link | alignleft aligncenter alignright |  bullist numlist   | code ',
      myPlugins: "link image code   table lists   ",

      myInit: {
        // images_upload_handler: this.image_upload_handler,
        // automatic_uploads: true,
        height: 500,

          images_upload_url: '/postAcceptor',
          images_dataimg_filter: function(img) {
           return !img.hasAttribute('internal-blob');  // blocks the upload of <img> elements with the attribute "internal-blob".
         },
        content_style: "img { max-width:100%;height:auto; }",

      }
    }

  },



  methods: {
    storeText: function() {
      let app = this;
      let formdat = this.$inertia.form(app.textblock);

      this.$inertia.visit('/text/store', {
        method: 'post',

        data: formdat,

        preserveState: true,
        preserveScroll: true,

        onSuccess: page => {
          app.editmode = false
        },
        onError: errors => {},
        onFinish: visit => {},
      })
    },
    prog: function(state) {
      console.log(state)
    },

  }

}
</script>
